export const BookingStatusConfig: Record<number, { label: string, color: string }> = {
    1: { label: 'Ожидание оплаты', color: 'bg-yellow-100 text-yellow-800' },
    2: { label: 'Отменено', color: 'bg-red-100 text-red-800' },
    3: { label: 'Подтверждено', color: 'bg-green-100 text-green-800' },
    4: { label: 'Ожидание', color: 'bg-yellow-100 text-yellow-800' },
    5: { label: 'Частичная оплата', color: 'bg-yellow-100 text-yellow-800' },
    6: { label: 'Подтверждено', color: 'bg-green-100 text-green-800' },
    7: { label: 'Отменено', color: 'bg-red-100 text-red-800' },
    8: { label: 'На ручном разборе', color: 'bg-orange-100 text-orange-800' }
}